interface InsuranceSummary {
  insuranceProvider?: string;
  policyNumber?: string;
}

export interface NoPatientBillingState {
  stored: boolean;
  effective: boolean;
  forcedByPrefix: boolean;
}

export function deriveNoPatientBillingState(
  casePrefix: string | null | undefined,
  storedChoice: boolean | null | undefined
): NoPatientBillingState {
  const stored = storedChoice === true;
  const forcedByPrefix = casePrefix?.trim().toUpperCase() === "AR";
  return { stored, effective: forcedByPrefix || stored, forcedByPrefix };
}

export function shouldCreateMissingInsuranceFollowUp(
  insurance: InsuranceSummary | null | undefined,
  effectiveNoPatientBilling: boolean
): boolean {
  if (effectiveNoPatientBilling) return false;
  return !insurance?.insuranceProvider || !insurance?.policyNumber;
}
